import { useQuery } from '@tanstack/react-query';
import { searchSuggestionsByTitle } from '../../../apis/search-catalog';

const DEFAULT_LIMIT = 3;

interface SearchSuggestionsByTitleProps {
  value: string;
  limit?: number;
}

export const useSearchSuggestionsByTitle = ({
  value,
  limit = DEFAULT_LIMIT,
}: SearchSuggestionsByTitleProps) => {
  const getSuggestionsByTitle = async () => {
   return searchSuggestionsByTitle(value, limit);
  };

  return useQuery({
    queryKey: ['suggestions', value, limit],
    queryFn: getSuggestionsByTitle,
    retry: false,
    enabled: !!value && value.length >= 2,
    keepPreviousData: true,
  });
};
